module.exports = require('./helpers/bundle-url').getBundleURL('cfrUe') + "logo-dark.eefe0b7f.svg";